var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-mobile-shift-rows',{attrs:{"loading":_vm.loading,"rows":_vm.rows,"stats":_vm.stats,"search":_vm.search,"empty-icon":"mdi-food-off"}})
}
var staticRenderFns = []

export { render, staticRenderFns }